<template>
  <div class="index">
    <div class="index-con">
      <el-carousel class="swiper index-swiper" :arrow="'never'">
        <el-carousel-item class="swiper-item" v-for="(item, index) in bannerList" :key="index">
          <img class="swiper-item-img" :src="item.image_url" alt="" />
        </el-carousel-item>
      </el-carousel>
      <img class="index-img" src="@/assets/images/index_1.png" alt="" />
      <div class="four-lists">
        <div class="list">
          <div class="pic">
            <img src="@/assets/images/card-001.png" alt="" style="width: 130px;" />
          </div>
          <a
            href="https://www.iradstm.org/indexcn/index.html#/richTextEditor?nav_title=IADST科学院&nav_small_title=IADST介绍&nav_id=96&nav_pid=71">
            <span class=" littletitle">关于IADST</span>
          </a>
          <a href="https://www.iradstm.org/indexcn/index.html#/iadst-fellow">
            <span class="littletitle2">院士</span>
          </a>
          <a href="https://www.iradstm.org/indexcn/index.html#/iadst-associate-fellow">
            <span class="littletitle2">副院士</span>
          </a>
        </div>
        <div class="list">
          <div class="pic">
            <img src="@/assets/images/card-002.png" alt="" style="width: 140px;" />
          </div>
          <a href="https://www.iradstm.org/indexcn/index.html#/richTextEditor?nav_title=会议&nav_small_title=
IDS - 国际干燥大会&nav_id=90&nav_pid=73">
            <span class="littletitle">IDS大会</span>
          </a>
          <a href="https://www.iradstm.org/indexcn/index.html#/news-content?news_id=30934">
            <span class="littletitle2">近届IDS2024</span>
          </a>
          <a href="https://www.iradstm.org/indexcn/index.html#/news-content?news_id=30989">
            <span class="littletitle2">下届IDS2026</span>
          </a>
        </div>
        <div class="list">
          <div class="pic">
            <img src="@/assets/images/card-003.png" alt="" style="width: 90px;" />
          </div>
          <a href="https://www.iradstm.org/indexcn/index.html#/web-content?news_id=30997">
            <span class="littletitle">Drying Technology</span>
          </a>
          <a href="https://www.tandfonline.com/journals/ldrt20" target="_blank">
            <span class="littletitle2">期刊官网</span>
          </a>
          <a href="https://www.tandfonline.com/loi/ldrt20" target="_blank">
            <span class="littletitle2">最新发表</span>
          </a>
        </div>
        <div class="list">
          <div class="pic">
            <img src="@/assets/images/card-004.png" alt="" style="width: 180px;" />
          </div>
          <a href="https://www.iradstm.org/indexcn/index.html#/richTextEditor?nav_title=会员
&nav_small_title=团体会员介绍&nav_id=95&nav_pid=72">
            <span class="littletitle">团体会员</span>
          </a>
          <a href="https://www.iradstm.org/indexcn/index.html#/web-content?news_id=30998">
            <span class="littletitle2">干燥设备</span>
          </a>
          <a href="https://www.iradstm.org/indexcn/index.html#/web-content?news_id=30999">
            <span class="littletitle2">产业动态</span>
          </a>
        </div>
      </div>
      <div class="three-box">
        <div class="box-title">近期新闻</div>
      </div>
      <div class="one-box">
        <div class="left" v-for="(item, index) in newslist1" :key="index" @click="toDetail(item.news_id)">
          <img :src="item.image_url" alt="" />
          <div class="left-title">
            {{ item.writer }}
          </div>
          <div class="left-text">
            {{ item.news_title }}
          </div>
          <div class="more">详情</div>
        </div>
        <div class="right">
          <div class="top" v-for="(item, index) in newslist2" :key="index" @click="toDetail(item.news_id)">
            <div class="top-pic">
              <img class="big-pic" :src="item.image_url" alt="" />
            </div>
            <div class="top-con">
              <div class="top-title">
                {{ item.writer }}
              </div>
              <div class="top-text">
                {{ item.news_title }}
              </div>
              <div class="more">详情</div>
            </div>
          </div>
        </div>
      </div>
      <div class="box-center">
        <div @click="toMore('all')" class="more-all">更多...</div>
      </div>
      <div class="three-box">
        <div class="box-title">
          即将举行
        </div>
        <div class="three-lists">
          <div class="three-list cup" v-for="(item, index) in newslist" :key="index"
            @click="toDetailEvent(item.news_id)">
            <div>
              <div class="top">{{ item.writer }}</div>
              <div class="title">
                {{ item.news_title }}
              </div>
              <div class="time">{{ item.source }}</div>
            </div>
            <div class="text-center">
              <div>
                <img :src="item.image_url" alt="" />
              </div>
              <div class="more cup">详情</div>
            </div>
          </div>
        </div>
        <div class="box-center">
          <div @click="toMore2()" class="more-all">更多...</div>
        </div>
      </div>
      <div class="four-box">
        <div class="box-title">IRADSTM数据</div>
        <div class="four-lists">
          <div class="four-list" @click="toMore3()">
            <img src="@/assets/images/new-012.png" alt="" />
            <div class="num">30+</div>
            <div class="text">国家 ↗</div>
          </div>
          <div class="four-list" @click="toMore3()">
            <img src="@/assets/images/new-013.png" alt="" />
            <div class="num">200+</div>
            <div class="text">会员 ↗</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      s: 0.3,
      num: 0,
      len: 8,
      username: "",
      password: "",
      newslist: [],
      newslist1: [],
      newslist2: [],
      bannerList: [],
    };
  },
  onload() { },
  mounted() {
    this.getnewslist1();
    this.getnewslist2();
    this.bannerFn();
    this.getNewsList();
    this.getTitle();
  },
  onShow() { },
  methods: {
    getTitle() {
      document.title = "IRADSTM | International Research Association for Drying Science & Technology (Macao) 国际干燥科学与技术研究会";
    },
    getNewsList() {
      this.$http
        .news_list({
          page: 1,
          pagesize: 4,
          type_id: 836,
        })
        .then((res) => {
          this.newslist = res.data;
          console.log(res.data, "--111-");
        });
    },
    bannerFn() {
      this.$http
        .banner_list({
          type_id: 200,
        })
        .then((res) => {
          this.bannerList = res.data;
        });
    },
    toDetail(news_id) {
      this.$router.push({ path: "/news-content?news_id=" + news_id });
    },
    toDetailEvent(news_id) {
      this.$router.push({ path: "/events-content?news_id=" + news_id });
    },
    toMore2() {
      this.$router.push({ path: "/Upcoming-Events" });
    },
    toMore3() {
      this.$router.push({ path: "/members" });
    },
    toMore(info, type) {
      if (info == "all") {
        this.$router.push({ path: "/IRADSTM-News" });
      } else {
        this.$router.push({
          path:
            "/richTextEditor?type=" +
            type +
            "&news_id=" +
            info.news_id +
            "&nav_title=Membership&nav_small_title=IRADSTM-News",
        });
      }
    },
    getnewslist1() {
      this.$http.index_newslist1().then((res) => {
        this.newslist1 = res.data;
      });
    },
    getnewslist2() {
      this.$http.index_newslist2().then((res) => {
        this.newslist2 = res.data;
      });
    },
  },
};
</script>

<style scoped lang="less">
.index {
  border-top: 0;
}

.four-lists {
  display: flex;
  padding: 15px 0 50px;

  .list {
    width: calc(25% - 40px);
    margin-right: 50px;
    border-radius: 4px;
    height: 350px;
    padding: 30px 0;
    box-sizing: border-box;
    text-align: center;
    background: linear-gradient(to bottom, #deebf7, #e2f0d9);
  }

  .list:nth-last-of-type(1) {
    margin-right: 0;
  }

  .littletitle {
    font-size: 23px;
    font-weight: 800;
  }

  .littletitle2 {
    font-size: 18px;
    font-weight: 800;
  }

  img {
    width: 90px;
    height: auto;
  }

  .pic {
    height: 100px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  a {
    display: block;
    margin-top: 30px;
    cursor: pointer;
    font-weight: 500;
    transition: .3s all;
    color: #000;
  }

  a:hover {
    color: #f9b033;
  }
}

.four-box {
  .four-lists {
    margin-top: 50px;
    margin-bottom: 50px;
    display: flex;
    justify-content: center;
  }

  .four-list:hover {
    background: #487847;
  }

  .four-list {
    width: 400px;
    height: 200px;
    background: #5b965a;
    margin: 0 50px;
    transition: 0.3s all;
    cursor: pointer;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    color: #fff;
  }

  .num {
    margin-top: 16px;
    font-size: 60px;
    color: #fff;
    font-weight: 900;
    font-family: Canaro, Arial, sans-serif;
  }

  .text {
    font-size: 18px;
  }

  img {
    width: 32px;
    height: auto;
  }
}

.three-box {
  padding-bottom: 30px;

  .box-title {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .three-lists {
    display: flex;
    margin-top: 50px;
    margin-bottom: 50px;
    justify-content: space-between;

    .three-list {
      flex: 1;
      margin-right: 20px;
      padding: 32px 20px 24px;
      box-sizing: border-box;
      border-top: 10px solid #f9b033;
      background: hsla(0, 0%, 52.9%, 0.1);
      display: flex;
      flex-direction: column;
      justify-content: space-between;

      .top {
        font-size: 15px;
        min-height: 48px;
        font-weight: 700;
      }

      .title {
        margin-bottom: 10px;
        transition: color 0.3s;
        color: #5b965a;
        font-family: Canaro, Arial, sans-serif;
        font-size: 24px;
        font-weight: 700;
      }

      .text {
        font-size: 16px;
        margin-top: 20px;
        line-height: 1.5;
      }

      .time {
        font-size: 14px;
        font-weight: 500;
      }

      img {
        max-width: 100%;
        max-height: 90px;
        margin-top: 20px;
      }

      .more {
        margin-top: 28px;
        display: inline-block;
        padding: 10px;
        background: #5b965a44;
        transition: background-color 0.3s;
        color: #1f1f1f;
        font-family: Canaro, Arial, sans-serif;
        font-size: 16px;
        line-height: 24px;
        font-weight: 700;
        text-align: center;
      }
    }

    .text-center {
      text-align: center;
    }

    .three-list:hover {
      .title {
        color: #f9b033;
      }

      .more {
        background: #5b965a84;
      }
    }

    .three-list:nth-last-child(1) {
      margin-right: 0;
    }
  }
}

.box-center {
  display: flex;
  align-items: center;
  justify-content: center;
}

.more-all {
  background: #f9b033;
  display: inline-block;
  padding: 10px;
  cursor: pointer;
  transition: background-color 0.3s;
  color: #1f1f1f;
  font-family: Canaro, Arial, sans-serif;
  font-size: 16px;
  font-weight: 700;
  text-align: center;
  width: 140px;
  box-sizing: border-box;
  margin: 0 auto;
}

.box-title {
  position: relative;
  padding-bottom: 10px;
  color: #26262a;
  font-family: Canaro, Arial, sans-serif;
  font-size: 30px;
  line-height: 1.9;
  font-weight: 700;

  &::before {
    content: "";
    position: absolute;
    bottom: 0;
    left: 0;
    width: 200px;
    max-width: 100%;
    height: 6px;
    background-color: #5b965a;
  }
}

.two-box {
  margin: 10px auto;

  .two-swiper {
    margin: 50px 0;
    height: 350px !important;
  }

  .two-swiper-con {
    width: calc(100% - 280px);
    margin: 0 auto;
    display: flex;
    height: auto;

    .left {
      padding: 24px;
      box-sizing: border-box;
      flex: 1;
      background: rgb(249, 242, 236);
      cursor: pointer;
    }

    .top {
      font-size: 14px;
      line-height: 2;
      margin-bottom: 15px;
      font-family: Canaro, Arial, sans-serif;
    }

    .title {
      font-family: Canaro, Arial, sans-serif;
      font-size: 24px;
      font-weight: 700;
      margin-bottom: 16px;
    }

    .time {
      font-weight: 600;
      font-size: 16px;
      font-family: Canaro, Arial, sans-serif;
      margin-bottom: 16px;
    }

    .text {
      line-height: 2;
      font-size: 16px;
      margin-bottom: 16px;
    }

    .more {
      display: inline-block;
      padding: 10px;
      transition: background-color 0.3s;
      color: #1f1f1f;
      font-family: Canaro, Arial, sans-serif;
      font-size: 16px;
      line-height: 24px;
      font-weight: 700;
      text-align: center;
      background: #5b965a44;
      margin-bottom: 16px;
    }

    .right {
      flex-shrink: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      background: #f8f8f8;
      width: 265px;

      img {
        width: 50%;
        height: auto;
      }
    }
  }
}

.one-title {
  //max-width: 790px;
  margin: 54px auto;
  color: #26262a;
  font-family: Canaro, Arial, sans-serif;
  font-weight: 500;
  padding-bottom: 16px;
  font-size: 20px;
  position: relative;
  text-align: left;

  &::before {
    content: "";
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    left: 50%;
    transform: translateX(-50%);
    max-width: 100%;
    height: 6px;
    background-color: #5b965a;
  }
}

.index-img {
  margin: 10px 0;
  width: 100%;
  height: auto;
}

.one-box {
  margin: 0 auto 40px;
  display: flex;

  .left {
    flex-shrink: 0;
    width: 480px;
    background: #5b965a;
    padding: 6px 6px 17px;
    box-sizing: border-box;
    margin-right: 35px;

    .left-title {
      color: #fff;
      font-weight: 600;
      font-size: 16px;
      text-indent: 14px;
      // margin-bottom: 15px;
      cursor: pointer;
    }

    img {
      width: 100%;
      height: auto;
      cursor: pointer;
    }

    .left-text {
      color: #fff;
      margin-top: 15px;
      padding-left: 15px;
      //box-sizing: border-box;
      font-weight: 500;
      font-size: 24px;
      cursor: pointer;
    }
  }

  .right {
    flex: 1;

    .top {
      margin-bottom: 35px;
      background: #5b965a;
      padding: 6px;
      box-sizing: border-box;
      display: flex;
      height: 270px;

      .top-pic {
        width: 350px;
        flex-shrink: 0;
        position: relative;
        height: 100%;
        cursor: pointer;

        .big-pic {
          position: absolute;
          left: 0;
          top: 0;
          width: 100%;
          height: 100%;
          cursor: pointer;
        }

        .small-pic {
          height: 90%;
          width: auto;
          position: absolute;
          z-index: 9;
          left: 50%;
          top: 50%;
          transform: translate(-50%, -50%);
        }
      }

      .top-con {
        padding-left: 10px;
        box-sizing: border-box;
        flex: 1;

        .top-title {
          color: #fff;
          font-size: 15px;
          margin-top: 10px;
          font-weight: 600;
          cursor: pointer;
        }

        .top-text {
          margin-top: 20px;
          font-weight: 500;
          font-size: 24px;
          color: #fff;
          margin-bottom: 20px;
          cursor: pointer;
        }
      }
    }

    .top+.top {
      margin-bottom: 0;
    }

    .bottom {
      background: #5b965a;
      padding: 6px;
      box-sizing: border-box;
      display: flex;

      .bottom-pic {
        width: 350px;
        flex-shrink: 0;
      }

      .bottom-con {
        flex: 1;
        padding-left: 10px;
        padding-top: 20px;
        box-sizing: border-box;
      }

      .bottom-title {
        color: #fff;
        font-size: 14px;
      }

      .bottom-text {
        margin-top: 10px;
        font-weight: 500;
        font-size: 24px;
        color: #fff;
      }

      .bottom-pic img {
        width: 100%;
      }
    }
  }

  .more {
    background: #88ef86;
    padding: 10px 20px;
    display: inline-block;
    margin-left: 14px;
    font-weight: 500;
    font-size: 16px;
    margin-top: 15px;
    color: #1f1f1f;
    font-family: Canaro, Arial, sans-serif;
    cursor: pointer;
  }
}

.swiper,
.swiper-item {
  height: 390px;
}

.swiper-item {
  display: flex;
  overflow: hidden;
  align-items: center;
  justify-content: center;
}

.swiper-item-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.index-con {
  width: 1200px;
  margin: 0 auto;
}

.index {
  width: 100%;
}

@media screen and (max-width: 768px) {
  .index-con {
    width: 100%;

    .four-lists {
      display: block;
      padding: 0 10px;
      box-sizing: border-box;

      .list {
        margin-bottom: 10px;
        width: 100%;
      }
    }

    .three-box {
      padding: 10px;
      box-sizing: border-box;
    }

    .one-box {
      display: block;
      padding: 10px;
      box-sizing: border-box;

      .left {
        width: 100%;
      }

      .right {
        .top {
          display: block;
          height: auto;
        }

        .top-pic {
          height: 200px;
          width: 100%;
          overflow: hidden;
          display: flex;
          align-items: center;
          justify-content: center;

          .big-pic {
            width: 100%;
            height: auto;
            position: relative;
          }
        }

        .top-con {
          padding-bottom: 10px;
        }

      }
    }

    .three-lists {
      display: block;

      .three-list {
        margin-right: 0;
        margin-bottom: 10px;
      }
    }

    .four-box {
      padding: 10px;
      box-sizing: border-box;

      .four-lists {
        display: block;
        padding: 0;
      }

      .four-list {
        margin-left: 0;
        width: 100%;
        margin-bottom: 10px;
      }
    }
  }

  .swiper {
    height: 150px;
    min-height: 100px;
    overflow: hidden;

    .swiper-item {
      align-items: start;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/index.vue